// const path = 'http://192.168.0.49:3500'
// const path = 'https://test.iventos.tv'
const path = 'https://seneca.tv'

module.exports = {
    path,
}
